<click-charts [reports]="reports$ | async"></click-charts>